import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

const TemplateDeploymentChangeHistoryEmpty = () => {
  return (
    <EmptyState
      icon={EmptystateSearchNoResultsColored}
      title="No changes"
      caption="This deployment has no change history yet."
      announce
    />
  );
};

export default TemplateDeploymentChangeHistoryEmpty;
